export const environment = {
  production: true,
  buildId: '2689944659818471',
  configFile: 'config.json',
};
